import { createServerFn } from '@tanstack/react-start';

import { useAppSession } from '../../auth/session';
import { deleteSession } from '../../service/sessionService';

const logout = async () => {
  const session = await useAppSession();

  if (session.id) {
    await deleteSession(session.id);
  }

  await session.clear();

  return { success: true };
};

export const logoutFn = createServerFn({ method: 'POST' }).handler(logout);
